module.exports = __webpack_public_path__ + "img/sda.3a6e0487.svg";